@if (formGroup) {
    <curafida-card
        [formGroup]="formGroup"
        [title]="'CONTACT'"
        class="full-width no-left-right-margin">
        <ion-card-content>
            <curafida-text-input
                [formControlName]="'email'"
                [formGroup]="formGroup"
                [isMobile]="isMobile()"
                [label]="'EMAIL'"></curafida-text-input>
            @if (isUpdateEmailVisible$ | async) {
                <curafida-text-input
                    [formControlName]="'emailUpdate'"
                    [formGroup]="formGroup"
                    [isMobile]="isMobile()"
                    [label]="'UPDATE_EMAIL.NEW_EMAIL'">
                </curafida-text-input>
                @if (updateEmailService.updateEmail$ | async; as updateEmailResource) {
                    <div class="verification">
                        @if (!updateEmailResource.isVerified) {
                            <div
                                class="verification-box"
                                [class.half-width]="!isMobile()">
                                <label class="red">{{ 'UPDATE_EMAIL.VERIFICATION_NEEDED' | translate }}</label>
                                @if (updateEmailResource.isExpired) {
                                    <label class="red">
                                        {{ 'UPDATE_EMAIL.LINK_EXPIRED' | translate }}
                                    </label>
                                }
                                <ion-button
                                    class="btn-font-medium"
                                    (click)="updateEmailService.refreshVerification(user.username)"
                                    [disabled]="isEditEnabled">
                                    {{ 'UPDATE_EMAIL.SEND_AGAIN' | translate }}
                                </ion-button>
                            </div>
                        }
                    </div>
                }
            }
            <curafida-text-input
                [formControlName]="'phone'"
                [formGroup]="formGroup"
                [isMobile]="isMobile()"
                [label]="'PHONE'"></curafida-text-input>
            <curafida-text-input
                [formControlName]="'mobilePhone'"
                [formGroup]="formGroup"
                [isMobile]="isMobile()"
                [label]="'MOBILE_PHONE'"></curafida-text-input>
            @if (this.user?.roles?.includes(UserRoles.CAREGIVER) || this.user?.roles?.includes(UserRoles.SUPERVISOR)) {
                <curafida-text-input
                    [formControlName]="'company'"
                    [formGroup]="formGroup"
                    [isMobile]="isMobile()"
                    [label]="'OPERATING_SITE'"></curafida-text-input>
            }
            @if (!isNewUser() && (hasRightToModifyUser() || isOwnDetails())) {
                <curafida-save-cancel-button
                    (cancelEditEmit)="cancel$.emit(true)"
                    (saveInformationEmit)="save$.emit(true)"
                    (toggleEditEmit)="edit$.emit(!isEditEnabled)"
                    [element]="user"
                    [formGroup]="rootForm"
                    [isEditEnabled]="isEditEnabled"
                    [isMobile]="isMobile()"
                    [isNewElement]="isNewUser()"></curafida-save-cancel-button>
            }
        </ion-card-content>
    </curafida-card>
}
